import LoginComponent from './pages/login/LoginComponent';
import TransportationOrganizationComponent from './pages/transport-organizations/TransportationOrganizationComponent';
import BaggageIndexComponent from './pages/baggage/BaggageIndexComponent';
import BaggageCreateComponent from './pages/baggage/BaggageCreateComponent';
import BaggageAttachComponent from './pages/baggage/BaggageAttachComponent';
import BusTypeIndex from './pages/buses/BusTypeIndex';
import BusTypeCreate from './pages/buses/BusTypeCreate';
import BusesIndex from './pages/buses/BusesIndex';
import BusesCreate from './pages/buses/BusesCreate';
import DashboardOne from './pages/cashier_dashboard/DashboardOne';
import DashboardTwo from './pages/cashier_dashboard/DashboardTwo';
import CashierLogs from './pages/cashier_dashboard/CashierLogs';
import QrSection from './pages/cashier_dashboard/QrSection';
import Transporters from './pages/transporters/Transporters';
import Privileges from './pages/privilages/Privileges';
import Routes from './pages/routes/Routes';
import RouteCreate from './pages/routes/RouteCreate';
import Stations from './pages/stations/Stations';
import StationCreate from './pages/stations/StationCreate';
import SchedulesIndex from './pages/schedule/Schedules';
import ScheduleUpdate from './pages/schedule/ScheduleUpdate';
import ScheduleCreateComponent from './pages/schedule/ScheduleCreate';
import Services from './pages/services/Services';
import Tariffs from './pages/tariffs/Tariffs';
import TripsComponent from './pages/trips/TripsComponent';
import TripsCreateComponent from './pages/trips/TripsCreateComponent';
import ReturnServicesComponent from './pages/return-ticket/ReturnServicesComponent';
import SettingsComponent from './pages/settings/SettingsComponent';
import BookingComponent from './pages/booking/BookingComponent';
import MainComponent from './pages/main/MainComponent';
import Locations from './pages/locations/Locations';
import CreateLocations from './pages/locations/CreateLocation';
import PageNotFound from './pages/404/NotFoundComponent';
import Dispatchment from './pages/dispatchment/Dispatchment';
import Sales from './pages/sales/Sales';
import Administration from './pages/administration/Administration';
import Users from './pages/users/Users';
import UserRoles from './pages/user-roles/UserRoles';
import ApiClients from './pages/api-clients/ApiClients';
import Profile from './pages/users/Profile';
import UserRoleForm from './pages/user-roles/UserRolesForm';
import Cashiers from './pages/cashiers/Cashiers';
import TransporterReports from './pages/reports/TransporterReports';
//alx
import CitizenshipReports from './pages/reports/CitizenshipReports';
import MinistryReports from './pages/reports/ministry/MinistryReports';
import DispatcherReports from './pages/reports/dispatchers/DispatcherReports';
import ValidatorReport from './pages/reports/validators/ValidatorReport';
import Reports from './pages/reports/sales/Reports';
//alx
import OnlineReports from './pages/reports/online_sales/Reports';
import Reversals from './pages/reports/reversals/Reversals';
import Baggage from "./pages/reports/baggage/Baggage";
import Dashboard from './pages/dashboard/Dasboard';
import ScheduleNew from './pages/schedule/ScheduleNew';
import TripsUpdate from "./pages/trips/TripsUpdate";
import BookingList from "./pages/booking/BookingList";
//alx e-pos
import EposServicesComponent from './pages/epos/EposServicesComponent';
// import OnlineSales from "./pages/reports/online_sales/OnlineSales";
// import SalesReports from './pages/reports/sales/SalesReports';


const routes = [
    {
        path: '/',
        component: MainComponent,
        name: 'main',
        meta: {
            // permissions: ['edit articles']
        }
    },
    {
        path: '/transportation-organization',
        component: TransportationOrganizationComponent,
    },
    {
        path: '/dispatchment',
        component: Dispatchment,
    },
    {
        path: '/sales',
        component: Sales,
    },
    {
        path: '/administration',
        component: Administration,
    },
    {
        path: '/login',
        component: LoginComponent,
        name: 'login',
        meta: {
            guest: true
        }
    },
    {
        path: '/baggage',
        name: 'baggage',
        component: BaggageIndexComponent
    },
    {
        path: '/baggage/create',
        component: BaggageCreateComponent
    },
    {
        path: '/baggage-index/update/:id',
        component: BaggageCreateComponent,
        name: 'baggageIndex'
    },
    {
        path: '/baggage-shipping/create',
        component: BaggageAttachComponent,
        name: 'baggage-shipping-create'
    },
    {
        path: '/bus-types/:page?',
        component: BusTypeIndex
    },
    {
        path: '/bus-type/create',
        component: BusTypeCreate
    },
    {
        path: '/bus-type/update/:id',
        component: BusTypeCreate
    },
    {
        path: '/buses/index/:page?',
        component: BusesIndex
    },
    {
        path: '/buses/create',
        component: BusesCreate
    },
    {
        path: '/buses/update/:id',
        component: BusesCreate
    },
    {
        path: '/cashier/dashboard-one/:tab',
        component: DashboardOne
    },
    {
        path: '/cashier/dashboard-two/:id/:from/:to/:from_booked?',
        component: DashboardTwo,
        name: 'dashboard.two'
    },
/*
    {
        path: '/cashier/qr-section/:id',
        component: QrSection
    },
*/
    //alx e-pos
    {
        path: '/epos-services',
        component: EposServicesComponent,
        name: 'epos-services'
    },
    {
        path: '/cashier/qr-section/:id/:epos?',
        component: QrSection,
        name: 'qr-section'
    },
    {
        path: '/cashier-logs/:page?',
        component: CashierLogs
    },
    {
        path: '/privileges',
        name: 'privileges',
        component: Privileges
    },
    {
        path: '/transporters/:page?',
        component: Transporters
    },
    {
        path: '/users/:page?',
        component: Users,
        name: 'users'
    },
    {
        path: '/roles',
        component: UserRoles,
    },
    {
        path: '/api-clients',
        component: ApiClients,
    },
    {
        path: '/roles/form/:id?',
        component: UserRoleForm,
    },
    {
        path: '/cashiers',
        component: Cashiers
    },
    {
        path: '/routes/create',
        component: RouteCreate,
    },
    {
        path: '/routes/:page?',
        component: Routes
    },
    {
        path: '/routes/update/:id',
        component: RouteCreate,
    },
    {
        path: '/stations/create',
        component: StationCreate
    },
    {
        path: '/stations/update/:id',
        component: StationCreate
    },
    {
        path: '/stations/:page?',
        component: Stations,
        name: 'stations'
    },
    {
        path: '/schedule-new',
        component: ScheduleNew,
        name: 'schedule-new'
    },
    {
        path: '/schedule-new/:id',
        component: ScheduleNew,
        name: 'schedule-update'
    },
    {
        path: '/schedules/create',
        component: ScheduleCreateComponent
    },
    {
        path: '/schedules/:page?',
        component: SchedulesIndex,
        name: 'schedules'
    },
    {
        path: '/schedules/update/:id',
        component: ScheduleUpdate
    },
    {
        path: '/services',
        component: Services
    },
    {
        path: '/profile',
        component: Profile
    },
    {
        path: '/tariffs/:page?',
        component: Tariffs,
        name: 'tariffs'
    },
    {
        path: '/return-services',
        component: ReturnServicesComponent,
        name: 'return-services'
    },
    {
        path: '/booking-list',
        component: BookingList,
        name: 'booking-list'
    },
    {
        path: '/settings',
        component: SettingsComponent
    },
    {
        path: '/trips',
        component: TripsComponent,
        name: 'trips.index'
    },
    {
        path: '/trips/:id',
        component: TripsUpdate,
        name: 'trips.update'
    },
    {
        path: '/trips/create/:id?',
        component: TripsCreateComponent,
        name: 'trips.create'
    },
    {
        path: '/booking',
        component: BookingComponent
    },
    {
        path: '/locations/create',
        component: CreateLocations,
        name: 'locations_create'
    },
    {
        path: '/locations/:page?',
        component: Locations,
        name: 'locations'
    },
    {
        path: '/locations/update/:id',
        component: CreateLocations,
        name: 'locations_update'
    },
    {
        path: '/transporter-reports',
        component: TransporterReports,
        name: 'transporter_reports'
    },
//alx
    {
        path: '/citizenship-reports',
        component: CitizenshipReports,
        name: 'citizenship_reports'
    },
    {
        path: '/reports/ministry',
        component: MinistryReports,
        name: 'ministry_reports'
    },
    {
        path: '/reports/dispatcher',
        component: DispatcherReports,
        name: 'dispatcher_reports'
    },
    {
        path: '/reports/validator',
        component: ValidatorReport,
        name: 'validator_report'
    },
    //alx
    {
        path: '/reports/online-sales',
        component: OnlineReports,
        name: 'online_sales_reports'
    },
    {
        path: '/reports/sales',
        // component: SalesReports,
        component: Reports,
        name: 'sales_reports'
    },
    {
        path: '/reports/reversals',
        component: Reversals,
        name: 'reversals'
    },
    {
        path: '/reports/baggage',
        component: Baggage,
        name: 'baggage-report'
    },
	// {
	// 	path: '/reports/online-sales',
	// 	component: OnlineSales,
	// 	name: 'online_sales'
	// },
    {
        path: '/dashboard',
        component: Dashboard,
        name: 'dashboard'
    },
    {
        path: "*",
        component: PageNotFound
    }
];

export default routes;
